<template>
  <Icon
    name="Undo"
    :width="20"
    :height="22"
    :scale="25"
  >
    <path d="M255,102V0L127.5,127.5L255,255V153c84.15,0,153,68.85,153,153c0,84.15-68.85,153-153,153c-84.15,0-153-68.85-153-153H51
      c0,112.2,91.8,204,204,204s204-91.8,204-204S367.2,102,255,102z"/>
  </Icon>
</template>

<script>
import Icon from "@/manzana_library/components/Elements/Icon.vue";

export default {
  name: 'Undo',
  components: { Icon },
};
</script>
